import { AccessSettingsV1, SpeechLanguageV1 } from '@i-ark/models';
import { transformPageV1ToV2 } from './transformPageV1ToV2.js';

const transformComponentDataV1ToV2 = async (componentData) => {
  const supportedShapeColoring = componentData.access_settings === AccessSettingsV1.COLORING || componentData.access_settings === AccessSettingsV1.ALL;
  return {
    version: 2,
    lastEditorVersion: 1,
    originalVersion: 1,
    settings: {
      enabledFeatures: transformFeatures(componentData),
      latexSpeechLanguage: "none",
      crediting: "",
      speechLanguage: transformSpeechLanguage(componentData)
    },
    style: {
      colors: {
        textColor: "#000",
        inputTextColor: "#000"
      }
    },
    pages: await Promise.all(
      componentData.pages.map(
        async (page, index) => await transformPageV1ToV2(page, index, supportedShapeColoring)
      )
    )
  };
};
function transformFeatures(componentData) {
  return {
    richTextFormating: componentData.format,
    wiris: componentData.wirls !== false
  };
}
function transformSpeechLanguage(componentData) {
  switch (componentData.speech_language) {
    case SpeechLanguageV1.ENGLISH:
      return "en";
    case SpeechLanguageV1.FRENCH:
      return "fr";
    case SpeechLanguageV1.GERMAN:
      return "de";
    case SpeechLanguageV1.SPANISH:
      return "es";
    case SpeechLanguageV1.DANISH:
    default:
      return "da";
  }
}

export { transformComponentDataV1ToV2 };
//# sourceMappingURL=transformComponentDataV1ToV2.js.map
